import type { FeatureFlags } from "types/featureFlags";

import { useFlags } from "launchdarkly-react-client-sdk";

export const useFeatureFlags = () => useFlags<FeatureFlags>();
